export const panTiltTypeOptions = [
  { value: "CH4-UCv2", label: "CH4-UCv2" },
  { value: "JSys", label: "JSys" },
  { value: "JSysV2", label: "JSysV2" },
];

// PT options for SKU configuration
export const ptPrefillOptions = [
  { value: "BUILTIN", label: "Built in" },
  { value: "EXTERNAL", label: "External" },
  { value: "NONE", label: "None" },
] as const;

export type PtPrefillType = "BUILTIN" | "EXTERNAL" | "NONE";

export interface ISKUDeviceData {
  deviceType: string;
  model: string[];
  isPT?: boolean;
  panTiltType?: string;
  ptPrefill?: PtPrefillType;
}

export interface ISKUForm {
  skuNumber: string;
  configurationName: string;
  category: string;
  nodeCount: number | "";
  password?: string;
  hasRecordVideo?: boolean;
  defaultIp?: string;
  skuDataConfigurations: ISKUDeviceData[];
}

export const defaultSKUForm: ISKUForm = {
  skuNumber: "",
  configurationName: "",
  category: "",
  nodeCount: "",
  password: "",
  hasRecordVideo: true,
  defaultIp: "",
  skuDataConfigurations: [],
};

export const skuFormRules = {
  skuNumber: {
    required: true,
  },
  configurationName: {
    required: true,
  },
  category: {
    required: true,
  },
  nodeCount: {
    required: true,
    min: 1,
  },
  skuDataConfigurations: {
    deviceType: {
      required: true,
    },
    model: {
      required: true,
    },
    password: {
      minLength: 8,
    },
    panTiltType: {
      requiredWhenPT: true,
    },
  },
};

export const modelLabelMap: Record<string, string> = {
  gasleak: "Leak",
  liquidleak: "Liquid Leak",
  firesmoke: "Fire/Smoke",
  hardhat: "Hard Hat",
  agg: "Gate Guard",
  tlm: "Tank Level",
};

export const skuCategoryOptions = [
  { value: "System", label: "System" },
  { value: "Accessory", label: "Accessory" },
  { value: "Peripheral", label: "Peripheral" },
];
